export const OAUTH_POPUP_MESSAGE_SOURCE = 'ninety-oauth-popup';

export interface OAuthPopupSuccessMessage {
  source: typeof OAUTH_POPUP_MESSAGE_SOURCE;
  provider: string;
  code: string;
  state: string | null;
}

export interface OAuthPopupErrorMessage {
  source: typeof OAUTH_POPUP_MESSAGE_SOURCE;
  error: string;
}

export type OAuthPopupMessage = OAuthPopupSuccessMessage | OAuthPopupErrorMessage;
